import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { u as useKeyboardClick } from './utils.js';

const mapyToggleCss = ":host{--unchecked-color:rgba(1, 30, 57, 0.12);--hover-unchecked-color:rgba(153, 165, 176, 1);--disabled-unchecked-color:rgba(235, 237, 239, 1);--checked-color:rgba(30, 174, 0, 1);--hover-checked-color:rgba(27, 157, 0, 1);--disabled-checked-color:rgba(165, 223, 153, 1);--slider-color:#ffffff;background:var(--unchecked-color);color:var(--slider-color);border-radius:0.6em;user-select:none;display:inline-block;cursor:pointer;width:2.286em;height:1.143em;box-sizing:border-box;padding:0.21428571em;transition:background 50ms ease-in-out, outline-color 50ms ease-in-out}:host(:hover:not([disabled])),:host(:focus-visible){background:var(--hover-unchecked-color)}:host([checked]:hover:not([disabled])),:host([checked]:focus-visible){background:var(--hover-checked-color)}:host([checked]){background:var(--checked-color)}span{position:relative;display:block;width:0.715em;height:0.715em;border-radius:50%;background:currentColor;left:0px;transition:left 150ms ease-in-out}:host([checked]) span{left:1.143em}:host(:focus-visible){outline:2px solid var(--hover-unchecked-color);outline-offset:2px}:host(:focus-visible:active),:host([checked]:focus-visible){outline:2px solid var(--hover-checked-color)}:host([disabled]){background:var(--disabled-unchecked-color);pointer-events:none}:host([disabled][checked]){background:var(--disabled-checked-color);pointer-events:none}";

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
  if (kind === "m")
    throw new TypeError("Private method is not writable");
  if (kind === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapyToggle_originalTabIndex, _MapyToggle_cleanup, _MapyToggle_handleClick;
const MapyToggle$1 = /*@__PURE__*/ proxyCustomElement(class MapyToggle extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.change = createEvent(this, "change", 2);
    _MapyToggle_originalTabIndex.set(this, undefined);
    _MapyToggle_cleanup.set(this, null);
    _MapyToggle_handleClick.set(this, (event) => {
      if (!event.defaultPrevented && !this.disabled) {
        this.checked = !this.checked;
        this.change.emit(this.checked);
      }
    });
    this.disabled = false;
    this.checked = false;
  }
  watchPropHandler(newValue) {
    if (newValue) {
      this.hostElement.tabIndex = -1;
    }
    else {
      this.hostElement.tabIndex = __classPrivateFieldGet(this, _MapyToggle_originalTabIndex, "f");
    }
  }
  connectedCallback() {
    this.hostElement.addEventListener('click', __classPrivateFieldGet(this, _MapyToggle_handleClick, "f"), false);
    __classPrivateFieldSet(this, _MapyToggle_cleanup, useKeyboardClick(this.hostElement, [' ']), "f");
    if (!this.hostElement.hasAttribute('tabindex')) {
      this.hostElement.tabIndex = 0;
    }
    __classPrivateFieldSet(this, _MapyToggle_originalTabIndex, this.hostElement.getAttribute('tabindex'), "f");
    if (this.disabled) {
      this.hostElement.tabIndex = -1;
    }
    this.hostElement.addEventListener('click', __classPrivateFieldGet(this, _MapyToggle_handleClick, "f"), false);
  }
  disconnectedCallback() {
    var _a;
    this.hostElement.removeEventListener('click', __classPrivateFieldGet(this, _MapyToggle_handleClick, "f"), false);
    (_a = __classPrivateFieldGet(this, _MapyToggle_cleanup, "f")) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return h(Host, null, h("span", null));
  }
  get hostElement() { return this; }
  static get watchers() { return {
    "disabled": ["watchPropHandler"]
  }; }
  static get style() { return mapyToggleCss; }
}, [1, "mapy-toggle", {
    "disabled": [516],
    "checked": [516]
  }]);
_MapyToggle_originalTabIndex = new WeakMap(), _MapyToggle_cleanup = new WeakMap(), _MapyToggle_handleClick = new WeakMap();
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-toggle"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-toggle":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyToggle$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyToggle = MapyToggle$1;
const defineCustomElement = defineCustomElement$1;

export { MapyToggle, defineCustomElement };

//# sourceMappingURL=mapy-toggle.js.map